/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, DraggablePositionType } from '@components/atoms'
import { PdfDraggableView } from './PdfDraggableView'

import { useAppSelector } from '@redux/index'
import { SignPositionOffsetType } from '@schemas'

interface PropsType {
	url: string
	onStop: (e: DraggablePositionType) => void
	onSubmit: () => any
	onClose: () => void
	positionOffset?: SignPositionOffsetType
}

export const DraggableSignature = (props: PropsType) => {
	const { url, onStop, onSubmit, onClose } = props

	// redux state
	const selectedPosition: SignPositionOffsetType[] = useAppSelector(
		state => state.contract.selectedContractPosition,
	)

	const positionIdx = selectedPosition.findIndex(aPosition => aPosition.id === 'sign')
	const positionOffset: SignPositionOffsetType = selectedPosition[positionIdx]

	return (
		<PdfDraggableView
			onStop={onStop}
			onSubmit={onSubmit}
			onClose={onClose}
			positionOffset={positionOffset}
			disabled={true}
			isSignature={true}
		>
			<View css={style}>
				<img src={url} width={200} draggable={false} />
			</View>
		</PdfDraggableView>
	)
}

const style = css({})
